import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-xsd",
  "use": "icon-xsd-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-xsd\"><path fill=\"#333333\" d=\"M404.48 81.92h215.04v215.04h-215.04z m0 645.12h215.04v215.04h-215.04z m-358.4 0h215.04v215.04h-215.04z m716.8 0h215.04v215.04h-215.04z m-215.04-250.88v-143.36h-71.68v143.36h-358.4v215.04h71.68v-143.36h286.72v143.36h71.68v-143.36h286.72v143.36h71.68v-215.04z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol